import { AssignedContactTypes } from '../../types/assignedContact.type';
import { AssignedContactResponseTypes } from '../../types/response/assignedContact';

export const convertAssignedContactResponse = (
  item: AssignedContactResponseTypes
): AssignedContactTypes => {
  return {
    id: item.id,
    code: item.code,
    token: item.token,
    alias: item.alias,
    userContact: item.userContact,
  };
};
